export { InteractionTagPrimary } from './InteractionTagPrimary';
export { renderInteractionTagPrimary } from './renderInteractionTagPrimary';
export { useInteractionTagPrimary } from './useInteractionTagPrimary';
export { useInteractionTagPrimaryContextValues } from './useInteractionTagPrimaryContextValues';
export type {
  InteractionTagPrimarySlots,
  InteractionTagPrimaryProps,
  InteractionTagPrimaryState,
  InteractionTagPrimaryContextValues,
} from './InteractionTagPrimary.types';
